import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'
import { IMultiBankPosInsatallment } from '../models/models'

export class AddMultiBankAkOdePosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionAkOde/addMultiBankAkOdePosInsatallment',
      requesterInfo,
    })
  }

  public async addMultiBankAkOdePosInsatallment(request: IMultiBankPosInsatallment): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
